import { RouteRecordRaw } from 'vue-router';

declare module 'vue-router' {
  interface RouteMeta {
    requiresLogin: boolean,
    headerTitle: string | null
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('pages/account/LoginPage.vue'),
        meta: {
          requiresLogin: false,
          headerTitle: "Login"
        },
      },
      {
        path: '/account',
        name: 'Account',
        component: () => import('pages/account/AccountPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Account"
        },
      },
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('pages/account/SettingsPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Settings"
        },
      },
      {
        path: '/password-forgot',
        name: 'PasswordForgot',
        component: () => import('pages/account/PasswordForgotPage.vue'),
        meta: {
          requiresLogin: false,
          headerTitle: "Forgot Password"
        },
      },
      {
        path: '/password-reset',
        name: 'PasswordReset',
        component: () => import('pages/account/PasswordResetPage.vue'),
        meta: {
          requiresLogin: false,
          headerTitle: "Reset Password"
        },
      },
      {
        path: '/stock',
        name: 'Stock',
        component: () => import('pages/stock/StockPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Stock Feed"
        },
      },
      {
        path: '/budget-calculator',
        name: 'BudgetCalculator',
        component: () => import('pages/budgetcalculator/BudgetCalculatorPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Budget Calculator"
        },
      },
      {
        path: '',
        name: 'Customers',
        component: () => import('pages/customers/CustomersPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Customers"
        },
      },
      {
        path: '/customer/:id',
        name: 'Customer',
        component: () => import('pages/customers/CustomerPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: null
        },
      },
      {
        path: '/customer',
        name: 'CustomerNoId',
        component: () => import('pages/customers/CustomerPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: null
        },
      },
      {
        path: '/quick-quote',
        name: 'QuickQuote',
        component: () => import('pages/customers/QuickQuotePage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Create Quick Quote"
        },
      },
      {
        path: '/quick-quote/:id',
        name: 'ViewQuickQuote',
        component: () => import('pages/customers/QuickQuoteResultPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: null
        },
      },
      {
        path: '/new-proposal',
        name: 'NewProposal',
        component: () => import('pages/customers/NewProposalPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Create Proposal"
        }
      },
      {
        path: '/:catchAll(.*)*',
        component: () => import('pages/customers/CustomersPage.vue'),
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/customers/CustomersPage.vue'),
  },
];

export default routes;
